const Urls = {
  GOOD_NEIGHBOR_POLICY: 'https://www.zillow.com/z/info/good-neighbor-policy/',
  RENTAL_USER_TERMS: 'https://www.zillow.com/renter-hub/terms/Rental-User-Terms',
};

export default Urls;
